export default {
  getAudiences: state => state.audiences,
  getSelectedAudience: state => state.selectedAudience,
  getAudiencesNames: state => state.audiences.map(({ name }) => name)
}
